module.exports = __webpack_public_path__ + "static/media/333c43d1-c426-430f-8212-181239dd1bf6.e0496a0a.jpg";